<template>
  <header>
    <div class="navbar-fixed">
      <nav class="white">
        <div class="nav-wrapper white">
          <a :href="SITE_ROOT" class="brand-logo"><img class="responsive-img" :src="SITE_ROOT + 'images/logo.png'" alt="The Genius"></a>

          <a href="#" data-target="mobile-menu" class="sidenav-trigger"><i class="material-icons grey-text">menu</i></a>

          <ul class="right hide-on-med-and-down grey-text">
            <template v-for="(navItem, key) in navMenu">
              <li :key="key" v-if="typeof navItem.submenu !== 'undefined'">
                <a class="dropdown-trigger waves-effect" :data-target="'dropdown' + key">
                  {{ navItem.title }}
                  <i class="material-icons right" style="margin-right:0;">arrow_drop_down</i>
                </a>

                <ul :id="'dropdown' + key" class="dropdown-content">
                  <li v-for="(subNavItem, subKey) in navItem.submenu" :key="subKey">
                    <a :href="SITE_ROOT + subNavItem.filename">{{ subNavItem.title }}</a>
                  </li>
                </ul>
              </li>
              <li :key="key" v-else>
                <a class="waves-effect" :href="SITE_ROOT + navItem.filename">{{ navItem.title }}</a>
              </li>
            </template>

            <li v-show="isAuthenticated">
              <a class="dropdown-trigger waves-effect red white-text" data-target="dropdown-user">
                <i class="material-icons">person</i>
              </a>

              <ul id="dropdown-user" class="dropdown-content">
                <li v-for="item in menuItemList" :key="item.title">
                  <router-link :to="item.filename">
                    <i class="material-icons">{{ item.icon }}</i>
                    {{ item.title }}
                  </router-link>
                </li>
                <li>
                  <a @click="logout">
                    <i class="material-icons">exit_to_app</i>
                    Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>

    <div v-if="isAuthenticated" class="myaccount-nav container hide-on-small-only mt-4" style="padding-bottom:0;">
      <div class="row">
        <div class="col s3 center-align" v-for="item in menuItemList" :key="item.title">
          <router-link class="router-link" :to="item.filename">
            <i class="material-icons">{{ item.icon }}</i><br>
            {{ item.title }}
          </router-link>
        </div>
      </div>
    </div>

    <ul class="sidenav" id="mobile-menu">
      <li>
        <div class="user-view center-align">
          <a class="sidenav-close" :href="SITE_ROOT"><img :src="SITE_ROOT + 'images/logo.png'" alt="The Genius"></a>
        </div>
      </li>

      <div class="divider"></div>

      <template v-for="(navItem, key) in navMenu">
        <li :key="key" v-if="typeof navItem.submenu !== 'undefined'">
          <ul class="collapsible">
            <li>
              <a class="collapsible-header waves-effect">
                {{ navItem.title }}
                <i class="material-icons right dropdown-arrow">arrow_drop_down</i>
              </a>
              <div class="collapsible-body">
                <ul>
                  <li v-for="(subNavItem, subKey) in navItem.submenu" :key="subKey">
                    <a class="sidenav-close" :href="SITE_ROOT + subNavItem.filename">{{ subNavItem.title }}</a>
                  </li>
                </ul>
                <div class="divider"></div>
              </div>
            </li>
          </ul>
        </li>

        <li :key="key" v-else>
          <a class="waves-effect" :href="SITE_ROOT + navItem.filename">{{ navItem.title }}</a>
        </li>
      </template>

      <li v-show="isAuthenticated">
        <ul class="collapsible">
          <li>
            <a class="collapsible-header waves-effect red white-text">
              My Account
              <i class="material-icons right dropdown-arrow">arrow_drop_down</i>
            </a>
            <div class="collapsible-body">
              <ul>
                <li v-for="item in menuItemList" :key="item.title">
                  <router-link :to="item.filename" class="sidenav-close">
                    {{ item.title }}
                  </router-link>
                </li>
                <li>
                  <a class="sidenav-close" @click="logout">
                    Logout
                  </a>
                </li>
              </ul>
              <div class="divider"></div>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',

  data () {
    return {
      SITE_ROOT: process.env.VUE_APP_SITE_ROOT,

      // Main site navmenu - may pull from the API later
      navMenu: [
        {
          title: 'The Genius',
          submenu: [
            {
              title: 'The Power of Fun',
              filename: 'the-power-of-fun'
            }
            /*
            {
              title: 'Reading Programme',
              filename: 'reading-programme'
            },
            {
              title: 'Summer Camps',
              filename: 'summer-camp'
            }
            */
          ]
        },

        {
          title: 'The Genius Junior Preschool',
          filename: 'the-genius-junior'
        },

        {
          title: 'Bookshelf',
          submenu: [
            {
              title: 'Subscribe',
              filename: 'myaccount/subscribe'
            },
            {
              title: 'Give a Gift',
              filename: 'bookshelf-give-a-gift'
            },
            {
              title: 'What\'s Inside a Box',
              filename: 'bookshelf-inside-a-box'
            },
            {
              title: 'FAQs',
              filename: 'bookshelf-faqs'
            },
            {
              title: 'Login',
              filename: 'myaccount/'
            }
          ]
        },

        {
          title: 'About Us',
          submenu: [
            {
              title: 'About The Genius',
              filename: 'about-the-genius'
            },
            {
              title: 'Contact Us',
              filename: 'contact-details'
            }
            /*
            {
              title: 'Jobs at The Genius',
              filename: 'jobs-at-the-genius'
            },
            {
              title: 'Content Franchises',
              filename: 'content-franchises'
            }
            */
          ]
        }
        /*
        {
          title: 'Downloads',
          filename: 'downloads'
        }
        */
      ],

      // Menu item list, with icons and routes/links
      menuItemList: [
        { icon: 'card_membership', title: 'Subscriptions', filename: '/subscription' },
        { icon: 'local_shipping', title: 'Shipments', filename: '/shipment' },
        { icon: 'person', title: 'Profile', filename: '/profile' },
        { icon: 'home', title: 'Addresses', filename: '/address' }
      ]
    }
  },

  computed: {
    // Vuex store data that is required to show menu only to logged in users
    ...mapGetters(['isAuthenticated', 'user', 'subscribe']),

    thisRoute () {
      return this.$route.name
    }
  },

  methods: {
    // Logout method
    logout () {
      // Dispatch vuex store action, to call API logout
      this.$store.dispatch('AUTH_LOGOUT')
        .then(() => {
          // On logout, take user to login page
          this.$router.push('/')
        })
        .catch(() => {
          // If logout fails, due to expired session, take user to login page
          this.$router.push('/')
        })
    }
  }
}
</script>
